import clsx from 'clsx';
import Axios from "axios";
import { useSelector } from "react-redux";
import { getBaseURL } from "../../baseURL";
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import SendIcon from '@mui/icons-material/Send';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import Checkbox from '@mui/material/Checkbox';
import React, { useState, useEffect } from "react";
import {green, red} from '@mui/material/colors';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import RadioGroup from '@mui/material/RadioGroup';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';

import { Container, TextField, Button, Snackbar, InputLabel, MenuItem, Select, FormHelperText } from "@mui/material";

export const RequestAccess = () => {
  const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(2, 2),
    },
    paperSpacing: {
      paddingTop: "30px",
    },
    wrapper: {
      position: 'relative',
    },
    buttonSuccess: {
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
    buttonError: {
        backgroundColor: red[500],
        '&:hover': {
          backgroundColor: red[700],
        },
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -5,
      marginLeft: -12,
    },
    paperSpacing: {
      paddingTop: "30px",
    },
    helperText: {
      marginLeft: 0,
    },
  }));

  const classes = useStyles();
  // const [assetNumber, setAssetNumber] = useState();
  const [hasAccess, setHasAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
    const [printNeeded, setPrintNeeded] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userDeactivate, setuserDeactivate] = useState(false);
  const [classificationLevels, setClassificationLevles] = useState([]);
  const [businessJustification, setBusinessJustification] = useState("");
  const [selectedClassification, setSelectedClassification] = useState(0);
  const [submitError, setSubmitError] = useState({Error: false, Text: ""});
  // const [assetNumberError, setAssetNumberError] = useState({Error: false, Text: ""});
    const [businessJustificationError, setBusinessJustificationError] = useState({ Error: false, Text: "" });

    const [physicalLocationError, setPhysicalLocationError] = useState({ Error: false, Text: "" });
    const [operatingGroupError, setOperatingGroupError] = useState({ Error: false, Text: "" });
    const [jobTypeError, setJobTypeError] = useState({ Error: false, Text: "" });

  const buttonClassname = clsx({
    [classes.buttonError]: submitError.Error,
  });
  //New fields added
  const [emailNeeded, setEmailNeeded] = useState(false);
    const [physicalLocation, setPhysicalLocation] = useState('');
    const [operatingGroup, setOperatingGroup] = useState('');
    const [functionalRole, setFunctionalRole] = useState('');
    const [jobType, setJobType] = useState('');
    const [isCertifiedCountry, setIsCertifiedCountry] = useState(false);
    // Options for dropdowns
   
    const [countries, setCountries] = useState([]);
    const certifiedCountries = ["Australia", "Canada", "France", "Germany", "Ireland", "Japan", "Netherlands", "New Zealand", "Poland", "Singapore", "Sweden", "United Kingdom", "United States"];
    const groupOptions = ["OE", "Distributor"];
    const jobTypeOptions = ["Permanent", "Contractor", "Intern"];


    const normalize = (s) => (s ?? '').trim().toLowerCase();

  const currentUser = useSelector(state => state.auth);
  const config = {
    headers: {'Authorization': "Bearer " + currentUser.jwtIdToken.idToken}
    };
    useEffect(() => {
        if (classificationLevels.length === 0) {
            Axios.get(`${getBaseURL()}/admin/getclassificationlevels`, config)
                .then((response) => {
                    setClassificationLevles(response.data);
                })           

        }       

      if(selectedClassification === 0 && classificationLevels.length !== 0) {
      setSelectedClassification(classificationLevels[0].id);
    }

    if (currentUser.user.permissions !== undefined) {
      if (currentUser.user.permissions.length > 0) {
        if (currentUser.user.permissions.find(p => p.permissionName === "Access State").accountActive === false) {
          setuserDeactivate(true);
        }
      }
    }
    
        Axios
            .get("https://countriesnow.space/api/v0.1/countries/positions")
            .then((response) => {
                const list = (response?.data?.data || [])
                    .map((c) => c?.name)
                    .filter(Boolean)
                    .sort((a, b) => a.localeCompare(b));
                setCountries(list);
            })
            .catch((error) => {
                console.error("Error:", error);
                setCountries([]);
            });
    }, []);

    useEffect(() => {
        console.log("Physical Location changed:", physicalLocation);
    }, [physicalLocation]);

  const onClassificationLevelChange = event => {
    setSelectedClassification(parseInt(event.target.value));
  }

  const onPrintNeededChange = event => {
    setPrintNeeded(event.target.checked);
  }

    const onEmailNeededChange = (event) => {
        setEmailNeeded(event.target.checked);
    };

  const onBusinessJustificationChange = event => {
    setBusinessJustification(event.target.value);

    if(event.target.value) {
      setBusinessJustificationError({Error: false, Text: ""});
    }
  }

  

  const onSubmit = () => {

      // required fields checks
        const hasBusinessJustification = !!businessJustification?.trim();
        const hasPhysicalLocation = !!physicalLocation?.trim();
        const hasOperatingGroup = !!operatingGroup?.trim();
        const hasJobType = !!jobType?.trim();
      
            if (hasBusinessJustification && hasPhysicalLocation && hasOperatingGroup && hasJobType) {

      const AccessRequest = {
          RequestPrint: printNeeded,
          RequestEmail: emailNeeded,
        ClassLevel: selectedClassification,
        Justification: businessJustification,
         AssetNumber: 'NULL',
          AccessReason: 'NA',
          Country: physicalLocation,
          FunctionalRole: functionalRole,
          OperatingGroup: operatingGroup,
          JobType: jobType,
          IsCertifiedCountry: isCertifiedCountry
      }
      setIsLoading(true);
      Axios.post(`${getBaseURL()}/users/accessrequest/new`, AccessRequest, config)
        .then((response) => {
          setIsLoading(false);
          setIsSubmitted(true);
        })
        .catch((error) => {
          setSubmitError({Error: true, Text: error.response.data.message});
          setIsLoading(false);
        });
    }
    else {

        
          if (!hasBusinessJustification) {
                setBusinessJustificationError({ Error: true, Text: "Enter Justification" });
             }
            if (!hasPhysicalLocation) {
                setPhysicalLocationError({ Error: true, Text: "Select Physical Location" });
              }
           if (!hasOperatingGroup) {
                 setOperatingGroupError({ Error: true, Text: "Select Operating Group" });
               }
           if (!hasJobType) {
                setJobTypeError({ Error: true, Text: "Select Job Type" });
              }

    }
  }

  return (
    <Container>
      <Typography variant="h4">{userDeactivate ? "Your account has been deactivated. Please apply again for access." : "Request Access"}   </Typography>
      {!isSubmitted ?
        <React.Fragment>
          {/* {hasAccess ? (
            <Typography variant="subtitle1">To change your access level, please submit a new request below</Typography>
            ) : (
            <Typography  variant="subtitle1">You do not currently have access. Please submit a request</Typography>
            )} */}
          <Paper className={classes.root}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Access Level</FormLabel>
              <RadioGroup value={selectedClassification} onChange={onClassificationLevelChange} row>
                {classificationLevels.map((item, index) => {
                  return (
                    <FormControlLabel
                      value={item.id}
                      control={<Radio color="primary" />}
                      label={item.description}
                      labelPlacement="end"
                      key={item.id}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
            <FormGroup row>
              <FormControlLabel
                control={<Checkbox checked={printNeeded} onChange={onPrintNeededChange} color="primary" />}
                label="Print Access Needed?"
                          />

                          <FormControlLabel
                              control={<Checkbox checked={emailNeeded} onChange={onEmailNeededChange} color="primary" />}
                              label="Email Access Needed?"
                          />

                      </FormGroup>
                      {/* Physical Location Dropdown */}
                      <FormControl variant="outlined" fullWidth style={{ marginBottom: '20px' }}>
                          
                          <Autocomplete
                              options={countries}
                              value={physicalLocation}
                              isOptionEqualToValue={(option, value) => option === value}
                              onChange={(event, newValue) => {
                                  const selected = newValue || '';
                                  setPhysicalLocation(selected);

                                  // case-insensitive membership check
                                  const isCertified = certifiedCountries
                                      .map(normalize)
                                      .includes(normalize(selected));

                                  setIsCertifiedCountry(isCertified);
                                  if (selected) setPhysicalLocationError({ Error: false, Text: "" });
                              }}
                              freeSolo={false}
                              disableClearable={false}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Physical Location"
                                      variant="outlined"
                                      required
                                      error={physicalLocationError.Error}
                                      helperText={physicalLocationError.Error ? physicalLocationError.Text : null}
                                  />
                              )}
                          />

                        
                           

                      </FormControl>

                      {/* Operating Group Dropdown */}
                      <FormControl variant="outlined" fullWidth style={{ marginBottom: '20px' }} error={operatingGroupError.Error}>
                          <InputLabel id="operating-group-label">Operating Group</InputLabel>
                          <Select
                              labelId="operating-group-label"
                              value={operatingGroup}
                              onChange={(e) => { setOperatingGroup(e.target.value); if (e.target.value) setOperatingGroupError({ Error: false, Text: "" }); } }
                              label="Operating Group"
                              required
                          >
                              {groupOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
                          </Select>

                          {operatingGroupError.Error && (
                                  <FormHelperText>{operatingGroupError.Text}</FormHelperText>
                               )}

                      </FormControl>

                      {/* Functional Role Text Box */}
                      <TextField
                          label="Functional Role"
                          variant="outlined"
                          fullWidth
                          value={functionalRole}
                          onChange={(e) => setFunctionalRole(e.target.value)}
                          style={{ marginBottom: '20px' }}
                      />

                      {/* Job Type Dropdown */}
                      <FormControl variant="outlined" fullWidth style={{ marginBottom: '20px' }}
                          error={jobTypeError.Error}>
                          <InputLabel id="job-type-label">Job Type</InputLabel>
                          <Select
                              labelId="job-type-label"
                              value={jobType}

                              onChange={(e) => {
                                  setJobType(e.target.value);
                                       if (e.target.value) setJobTypeError({ Error: false, Text: "" });
                              }}

                              label="Job Type"
                              required
                          >
                              {jobTypeOptions.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
                          </Select>

                          {jobTypeError.Error && (
                                  <FormHelperText>{jobTypeError.Text}</FormHelperText>
                               )}

                      </FormControl>
            {/* <TextField
              variant="outlined"
              label="Computer Asset Number"
              helperText={<span><span style={{ color: "red" }}>Important: </span> You will NOT get the required software to view drawings if this is missing or incorrect</span>}
              value={assetNumber}
              onChange={onAssetNumberChange}
              FormHelperTextProps={{ classes: { root: classes.helperText } }}
              error={assetNumberError.Error}
            /> */}
            <TextField
              id="businessJustification"
              value={businessJustification}
              onChange={onBusinessJustificationChange}
              variant="outlined"
              label="Business Justification"
              fullWidth
              multiline
              rows="10"
              helperText={businessJustificationError.Error ? businessJustificationError.Text : null}
              error={businessJustificationError.Error}
              FormHelperTextProps={{ classes: { root: classes.helperText } }}
              style={{ marginTop: '10px' }}
            />
            <br />
            <br />
            <span className={classes.wrapper}>
              <Button
                id="submit"
                color="primary"
                variant="contained"
                onClick={onSubmit}
                className={buttonClassname}
                disabled={isLoading}
              >
                {(!isLoading && !submitError.Error) && <SendIcon />}
                {(!isLoading && submitError.Error) &&
                  <ErrorIcon />
                }
                &nbsp;Submit
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </span>

            {submitError.Error &&
              <Typography variant="subtitle1" style={{ color: "red", marginTop: 10 }}>{submitError.Text}</Typography>
            }
          </Paper>
        </React.Fragment>
        :
        <Paper className={classes.root}>
          <Typography variant="h6">
            <CheckIcon />&nbsp;Your request has been submitted and a confirmation email has been sent
          </Typography>
        </Paper>
      }
    </Container>
  )
}